/* eslint-disable */
import { CompressedStreamWriter, Stream, CompressedStreamReader } from './index';
import { Save } from '@syncfusion/ej2-file-utils';
import { Utils } from './utils';
const CRC32TABLE = [];
/// <summary>
/// Size of the int value in bytes.
/// </summary>
const INT_SIZE = 4;
/// <summary>
/// Size of the short value in bytes.
/// </summary>
const SHORT_SIZE = 2;
/// <summary>
/// End of central directory signature.
/// </summary>
const CentralDirectoryEndSignature = 0x06054b50;
/// <summary>
/// Offset to the size field in the End of central directory record.
/// </summary>
const CentralDirSizeOffset = 12;
/// <summary>
/// Central header signature.
/// </summary>
const CentralHeaderSignature = 0x02014b50;
/// <summary>
/// Buffer size.
/// </summary>
const BufferSize = 4096;
/**
 * class provide compression library
 * ```typescript
 * let archive = new ZipArchive();
 * archive.compressionLevel = 'Normal';
 * let archiveItem = new ZipArchiveItem(archive, 'directoryName\fileName.txt');
 * archive.addItem(archiveItem);
 * archive.save(fileName.zip);
 * ```
 */
export class ZipArchive {
    get items() {
        return this.files;
    }
    /**
     * gets compression level
     */
    get compressionLevel() {
        return this.level;
    }
    /**
     * sets compression level
     */
    set compressionLevel(level) {
        this.level = level;
    }
    /**
     * gets items count
     */
    get length() {
        if (this.files === undefined) {
            return 0;
        }
        return this.files.length;
    }
    /**
     * constructor for creating ZipArchive instance
     */
    constructor() {
        if (CRC32TABLE.length === 0) {
            ZipArchive.initCrc32Table();
        }
        this.files = [];
        this.level = 'Normal';
        Save.isMicrosoftBrowser = !(!navigator.msSaveBlob);
    }
    /**
     * add new item to archive
     * @param {ZipArchiveItem} item - item to be added
     * @returns {void}
     */
    addItem(item) {
        if (item === null || item === undefined) {
            throw new Error('ArgumentException: item cannot be null or undefined');
        }
        for (let i = 0; i < this.files.length; i++) {
            let file = this.files[i];
            if (file instanceof ZipArchiveItem) {
                if (file.name === item.name) {
                    throw new Error('item with same name already exist');
                }
            }
        }
        this.files.push(item);
    }
    /**
     * add new directory to archive
     * @param directoryName directoryName to be created
     * @returns {void}
     */
    addDirectory(directoryName) {
        if (directoryName === null || directoryName === undefined) {
            throw new Error('ArgumentException: string cannot be null or undefined');
        }
        if (directoryName.length === 0) {
            throw new Error('ArgumentException: string cannot be empty');
        }
        if (directoryName.slice(-1) !== '/') {
            directoryName += '/';
        }
        if (this.files.indexOf(directoryName) !== -1) {
            throw new Error('item with same name already exist');
        }
        this.files.push(directoryName);
    }
    /**
     * gets item at specified index
     * @param {number} index - item index
     * @returns {ZipArchiveItem}
     */
    getItem(index) {
        if (index >= 0 && index < this.files.length) {
            return this.files[index];
        }
        return undefined;
    }
    /**
     * determines whether an element is in the collection
     * @param {string | ZipArchiveItem} item - item to search
     * @returns {boolean}
     */
    contains(item) {
        return this.files.indexOf(item) !== -1 ? true : false;
    }
    open(base64String) {
        //return promise = new Promise((resolve: Function, reject: Function) => {
        let zipArchive = this;
        let zipByteArray = Utils.encodedString(base64String);
        if (zipByteArray.length == 0)
            throw new DOMException("stream");
        let stream = new Stream(zipByteArray);
        //let lCentralDirEndPosition = this.findValueFromEnd( arrBuffer, Constants.CentralDirectoryEndSignature, 65557 );
        let lCentralDirEndPosition = ZipArchive.findValueFromEnd(stream, CentralDirectoryEndSignature, 65557);
        if (lCentralDirEndPosition < 0)
            throw new DOMException("Can't locate end of central directory record. Possible wrong file format or archive is corrupt.");
        // Step2. Locate central directory and iterate through all items
        stream.position = lCentralDirEndPosition + CentralDirSizeOffset;
        let iCentralDirSize = ZipArchive.ReadInt32(stream);
        let lCentralDirPosition = lCentralDirEndPosition - iCentralDirSize;
        // verify that this is really central directory
        stream.position = lCentralDirPosition;
        this.readCentralDirectoryDataAndExtractItems(stream);
        //});
        // let zipArchive: ZipArchive = this;
        //let promise: Promise<ZipArchive>;
        // return promise = new Promise((resolve: Function, reject: Function) => {
        //     let reader: FileReader = new FileReader();
        //     reader.onload = (e: Event) => {
        //         let data: Uint8Array = new Uint8Array((e.target as any).result);
        //         let zipReader: ZipReader = new ZipReader(data);
        //         zipReader.readEntries().then((entries: ZipEntry[]) => {
        //             for (let i: number = 0; i < entries.length; i++) {
        //                 let entry: ZipEntry = entries[i];
        //                 let item: ZipArchiveItem = new ZipArchiveItem(zipArchive, entry.fileName);
        //                 item.data = entry.data;
        //                 item.compressionMethod = entry.compressionMethod;
        //                 item.crc = entry.crc;
        //                 item.lastModified = entry.lastModified;
        //                 item.lastModifiedDate = entry.lastModifiedDate;
        //                 item.size = entry.size;
        //                 item.uncompressedSize = entry.uncompressedSize;
        //                 zipArchive.addItem(item);
        //             }
        //             resolve(zipArchive);
        //         });
        //     };
        //     reader.readAsArrayBuffer(fileName);
        // });
    }
    /// <summary>
    /// Read central directory record from the stream.
    /// </summary>
    /// <param name="stream">Stream to read from.</param>
    readCentralDirectoryDataAndExtractItems(stream) {
        if (stream == null)
            throw new DOMException("stream");
        let itemHelper;
        while (ZipArchive.ReadInt32(stream) == CentralHeaderSignature) {
            itemHelper = new ZipArchiveItemHelper();
            itemHelper.readCentralDirectoryData(stream);
            itemHelper;
            // let item: ZipArchiveItem = new ZipArchiveItem(this);
            // item.ReadCentralDirectoryData(stream);
            // m_arrItems.Add(item);
        }
        itemHelper.readData(stream, itemHelper.checkCrc);
        itemHelper.decompressData();
        this.files.push(new ZipArchiveItem(itemHelper.unCompressedStream.buffer, itemHelper.name));
    }
    /**
     * save archive with specified file name
     * @param {string} fileName save archive with specified file name
     * @returns {Promise<ZipArchive>}
     */
    save(fileName) {
        if (fileName === null || fileName === undefined || fileName.length === 0) {
            throw new Error('ArgumentException: fileName cannot be null or undefined');
        }
        if (this.files.length === 0) {
            throw new Error('InvalidOperation');
        }
        let zipArchive = this;
        let promise;
        return promise = new Promise((resolve, reject) => {
            zipArchive.saveInternal(fileName, false).then(() => {
                resolve(zipArchive);
            });
        });
    }
    /**
     * Save archive as blob
     * @return {Promise<Blob>}
     */
    saveAsBlob() {
        let zipArchive = this;
        let promise;
        return promise = new Promise((resolve, reject) => {
            zipArchive.saveInternal('', true).then((blob) => {
                resolve(blob);
            });
        });
    }
    saveInternal(fileName, skipFileSave) {
        let zipArchive = this;
        let promise;
        return promise = new Promise((resolve, reject) => {
            let zipData = [];
            let dirLength = 0;
            for (let i = 0; i < zipArchive.files.length; i++) {
                let compressedObject = this.getCompressedData(this.files[i]);
                compressedObject.then((data) => {
                    dirLength = zipArchive.constructZippedObject(zipData, data, dirLength, data.isDirectory);
                    if (zipData.length === zipArchive.files.length) {
                        let blob = zipArchive.writeZippedContent(fileName, zipData, dirLength, skipFileSave);
                        resolve(blob);
                    }
                });
            }
        });
    }
    /**
     * release allocated un-managed resource
     * @returns {void}
     */
    destroy() {
        if (this.files !== undefined && this.files.length > 0) {
            for (let i = 0; i < this.files.length; i++) {
                let file = this.files[i];
                if (file instanceof ZipArchiveItem) {
                    file.destroy();
                }
                file = undefined;
            }
            this.files = [];
        }
        this.files = undefined;
        this.level = undefined;
    }
    getCompressedData(item) {
        let zipArchive = this;
        let promise = new Promise((resolve, reject) => {
            if (item instanceof ZipArchiveItem) {
                let reader = new FileReader();
                reader.onload = () => {
                    let input = new Uint8Array(reader.result);
                    let data = {
                        fileName: item.name, crc32Value: 0, compressedData: [],
                        compressedSize: undefined, uncompressedDataSize: input.length, compressionType: undefined,
                        isDirectory: false
                    };
                    if (zipArchive.level === 'Normal') {
                        zipArchive.compressData(input, data, CRC32TABLE);
                        let length = 0;
                        for (let i = 0; i < data.compressedData.length; i++) {
                            length += data.compressedData[i].length;
                        }
                        data.compressedSize = length;
                        data.compressionType = '\x08\x00'; //Deflated = 8
                    }
                    else {
                        data.compressedSize = input.length;
                        data.crc32Value = zipArchive.calculateCrc32Value(0, input, CRC32TABLE);
                        data.compressionType = '\x00\x00'; // Stored = 0
                        data.compressedData.push(input);
                    }
                    resolve(data);
                };
                reader.readAsArrayBuffer(item.data);
            }
            else {
                let data = {
                    fileName: item, crc32Value: 0, compressedData: '', compressedSize: 0, uncompressedDataSize: 0,
                    compressionType: '\x00\x00', isDirectory: true
                };
                resolve(data);
            }
        });
        return promise;
    }
    compressData(input, data, crc32Table) {
        let compressor = new CompressedStreamWriter(true);
        let currentIndex = 0;
        let nextIndex = 0;
        do {
            if (currentIndex >= input.length) {
                compressor.close();
                break;
            }
            nextIndex = Math.min(input.length, currentIndex + 16384);
            let subArray = input.subarray(currentIndex, nextIndex);
            data.crc32Value = this.calculateCrc32Value(data.crc32Value, subArray, crc32Table);
            compressor.write(subArray, 0, nextIndex - currentIndex);
            currentIndex = nextIndex;
        } while (currentIndex <= input.length);
        data.compressedData = compressor.compressedData;
        compressor.destroy();
    }
    constructZippedObject(zipParts, data, dirLength, isDirectory) {
        let extFileAttr = 0;
        let date = new Date();
        if (isDirectory) {
            extFileAttr = extFileAttr | 0x00010; // directory flag
        }
        extFileAttr = extFileAttr | (0 & 0x3F);
        let header = this.writeHeader(data, date);
        let localHeader = 'PK\x03\x04' + header + data.fileName;
        let centralDir = this.writeCentralDirectory(data, header, dirLength, extFileAttr);
        zipParts.push({ localHeader: localHeader, centralDir: centralDir, compressedData: data });
        return dirLength + localHeader.length + data.compressedSize;
    }
    writeHeader(data, date) {
        let zipHeader = '';
        zipHeader += '\x0A\x00' + '\x00\x00'; // version needed to extract & general purpose bit flag
        zipHeader += data.compressionType; // compression method Deflate=8,Stored=0
        zipHeader += this.getBytes(this.getModifiedTime(date), 2); // last modified Time
        zipHeader += this.getBytes(this.getModifiedDate(date), 2); // last modified date
        zipHeader += this.getBytes(data.crc32Value, 4); // crc-32 value
        zipHeader += this.getBytes(data.compressedSize, 4); // compressed file size
        zipHeader += this.getBytes(data.uncompressedDataSize, 4); // uncompressed file size
        zipHeader += this.getBytes(data.fileName.length, 2); // file name length
        zipHeader += this.getBytes(0, 2); // extra field length
        return zipHeader;
    }
    writeZippedContent(fileName, zipData, localDirLen, skipFileSave) {
        let cenDirLen = 0;
        let buffer = [];
        for (let i = 0; i < zipData.length; i++) {
            let item = zipData[i];
            cenDirLen += item.centralDir.length;
            buffer.push(this.getArrayBuffer(item.localHeader));
            while (item.compressedData.compressedData.length) {
                buffer.push(item.compressedData.compressedData.shift().buffer);
            }
        }
        for (let i = 0; i < zipData.length; i++) {
            buffer.push(this.getArrayBuffer(zipData[i].centralDir));
        }
        buffer.push(this.getArrayBuffer(this.writeFooter(zipData, cenDirLen, localDirLen)));
        let blob = new Blob(buffer, { type: 'application/zip' });
        if (!skipFileSave) {
            Save.save(fileName, blob);
        }
        return blob;
    }
    writeCentralDirectory(data, localHeader, offset, externalFileAttribute) {
        let directoryHeader = 'PK\x01\x02' +
            this.getBytes(0x0014, 2) + localHeader + // inherit from file header
            this.getBytes(0, 2) + // comment length
            '\x00\x00' + '\x00\x00' + // internal file attributes 
            this.getBytes(externalFileAttribute, 4) + // external file attributes
            this.getBytes(offset, 4) + // local fileHeader relative offset
            data.fileName;
        return directoryHeader;
    }
    writeFooter(zipData, centralLength, localLength) {
        let dirEnd = 'PK\x05\x06' + '\x00\x00' + '\x00\x00' +
            this.getBytes(zipData.length, 2) + this.getBytes(zipData.length, 2) +
            this.getBytes(centralLength, 4) + this.getBytes(localLength, 4) +
            this.getBytes(0, 2);
        return dirEnd;
    }
    getArrayBuffer(input) {
        let a = new Uint8Array(input.length);
        for (let j = 0; j < input.length; ++j) {
            a[j] = input.charCodeAt(j) & 0xFF;
        }
        return a.buffer;
    }
    getBytes(value, offset) {
        let bytes = '';
        for (let i = 0; i < offset; i++) {
            bytes += String.fromCharCode(value & 0xff);
            value = value >>> 8;
        }
        return bytes;
    }
    getModifiedTime(date) {
        let modTime = date.getHours();
        modTime = modTime << 6;
        modTime = modTime | date.getMinutes();
        modTime = modTime << 5;
        return modTime = modTime | date.getSeconds() / 2;
    }
    getModifiedDate(date) {
        let modiDate = date.getFullYear() - 1980;
        modiDate = modiDate << 4;
        modiDate = modiDate | (date.getMonth() + 1);
        modiDate = modiDate << 5;
        return modiDate = modiDate | date.getDate();
    }
    calculateCrc32Value(crc32Value, input, crc32Table) {
        crc32Value ^= -1;
        for (let i = 0; i < input.length; i++) {
            crc32Value = (crc32Value >>> 8) ^ crc32Table[(crc32Value ^ input[i]) & 0xFF];
        }
        return (crc32Value ^ (-1));
    }
    /**
     * construct cyclic redundancy code table
     * @private
     */
    static initCrc32Table() {
        let i;
        for (let j = 0; j < 256; j++) {
            i = j;
            for (let k = 0; k < 8; k++) {
                i = ((i & 1) ? (0xEDB88320 ^ (i >>> 1)) : (i >>> 1));
            }
            CRC32TABLE[j] = i;
        }
    }
    static findValueFromEnd(stream, value, maxCount) {
        if (stream == null)
            throw new DOMException("stream");
        //   if( !stream.CanSeek || !stream.CanRead )
        //     throw new ArgumentOutOfRangeException( "We need to have seekable and readable stream." );
        // read last 4 bytes and compare with required value
        let lStreamSize = stream.inputStream.buffer.byteLength;
        if (lStreamSize < 4)
            return -1;
        let arrBuffer = new Uint8Array(4);
        let lLastPos = Math.max(0, lStreamSize - maxCount);
        let lCurrentPosition = lStreamSize - 1 - INT_SIZE;
        stream.position = lCurrentPosition;
        stream.read(arrBuffer, 0, INT_SIZE);
        let uiCurValue = arrBuffer[0];
        let bFound = (uiCurValue == value);
        if (!bFound) {
            while (lCurrentPosition > lLastPos) {
                // remove unnecessary byte and replace it with new value.
                uiCurValue <<= 8;
                lCurrentPosition--;
                stream.position = lCurrentPosition;
                uiCurValue += stream.readByte();
                if (uiCurValue == value) {
                    bFound = true;
                    break;
                }
            }
        }
        return bFound ? lCurrentPosition : -1;
    }
    /// <summary>
    /// Extracts Int32 value from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    /// <returns>Extracted value.</returns>
    static ReadInt32(stream) {
        let buffer = new Uint8Array(INT_SIZE);
        if (stream.read(buffer, 0, INT_SIZE) != INT_SIZE) {
            throw new DOMException("Unable to read value at the specified position - end of stream was reached.");
        }
        return Utils.bitConverterToInt32(buffer, 0);
    }
    /// <summary>
    /// Extracts Int16 value from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    /// <returns>Extracted value.</returns>
    static ReadInt16(stream) {
        let buffer = new Uint8Array(SHORT_SIZE);
        if (stream.read(buffer, 0, SHORT_SIZE) != SHORT_SIZE) {
            throw new DOMException("Unable to read value at the specified position - end of stream was reached.");
        }
        return Utils.bitConverterToInt16(buffer, 0);
    }
    /// <summary>
    /// Extracts unsigned Int16 value from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    /// <returns>Extracted value.</returns>
    static ReadUInt16(stream) {
        {
            let buffer = new Uint8Array(SHORT_SIZE);
            if (stream.read(buffer, 0, SHORT_SIZE) != SHORT_SIZE) {
                throw new DOMException("Unable to read value at the specified position - end of stream was reached.");
            }
            return Utils.bitConverterToInt16(buffer, 0);
        }
    }
}
export class ZipArchiveItemHelper {
    constructor() {
        /// <summary>
        /// Zip header signature.
        /// </summary>
        this.headerSignature = 0x04034b50;
        /// <summary>
        /// Indicates whether we should check Crc value when reading item's data. Check
        /// is performed when user gets access to decompressed data for the first time.
        /// </summary>
        this.checkCrc = true;
        /// <summary>
        /// Crc.
        /// </summary>
        this.crc32 = 0;
    }
    /// <summary>
    /// Read data from the stream based on the central directory.
    /// </summary>
    /// <param name="stream">Stream to read data from, stream.Position must point at just after correct file header.</param>
    readCentralDirectoryData(stream) {
        // on the current moment we ignore "version made by" and "version needed to extract" fields.
        stream.position += 4;
        this.options = ZipArchive.ReadInt16(stream);
        this.compressionMethod = ZipArchive.ReadInt16(stream);
        this.checkCrc = (this.compressionMethod != 99); //COmpression.Defalte != SecurityConstants.AES
        //m_bCompressed = true;
        // on the current moment we ignore "last mod file time" and "last mod file date" fields.
        let lastModified = ZipArchive.ReadInt32(stream);
        //LastModified = ConvertToDateTime(lastModified);
        this.crc32 = Utils.bitConverterToUInt32(ZipArchive.ReadInt32(stream));
        this.compressedSize = ZipArchive.ReadInt32(stream);
        this.originalSize = ZipArchive.ReadInt32(stream);
        let iFileNameLength = ZipArchive.ReadInt16(stream);
        let iExtraFieldLenth = ZipArchive.ReadInt16(stream);
        let iCommentLength = ZipArchive.ReadInt16(stream);
        // on the current moment we ignore and "disk number start" (2 bytes),
        // "internal file attributes" (2 bytes).
        stream.position += 4;
        this.externalAttributes = ZipArchive.ReadInt32(stream);
        this.localHeaderOffset = ZipArchive.ReadInt32(stream);
        let arrBuffer = new Uint8Array(iFileNameLength);
        stream.read(arrBuffer, 0, iFileNameLength);
        let m_strItemName = Utils.byteToString(arrBuffer);
        m_strItemName = m_strItemName.replace("\\", "/");
        this.name = m_strItemName;
        stream.position += iExtraFieldLenth + iCommentLength;
        if (this.options != 0)
            this.options = 0;
    }
    /// <summary>
    /// Reads zipped data from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    /// <param name="checkCrc">Indicates whether we should check crc value after data decompression.</param>
    readData(stream, checkCrc) {
        if (stream.length == 0)
            throw new DOMException("stream");
        stream.position = this.localHeaderOffset;
        this.checkCrc = checkCrc;
        this.readLocalHeader(stream);
        this.readCompressedData(stream);
    }
    decompressData() {
        if (this.compressionMethod == 8) {
            if (this.originalSize > 0) {
                this.decompressDataOld();
            }
        }
    }
    decompressDataOld() {
        let reader = new CompressedStreamReader(this.compressedStream, true);
        let decompressedData;
        if (this.originalSize > 0)
            decompressedData = new Stream(new Uint8Array(this.originalSize));
        let arrBuffer = new Uint8Array(BufferSize);
        let iReadBytes;
        let past = new Uint8Array(0);
        while ((iReadBytes = reader.read(arrBuffer, 0, BufferSize)) > 0) {
            //             past = new Uint8Array(decompressedData.length);
            // let currentBlock: Uint8Array = arrBuffer.subarray(0, iReadBytes);
            decompressedData.write(arrBuffer.subarray(0, iReadBytes), 0, iReadBytes);
        }
        this.unCompressedStream = decompressedData.toByteArray();
        //   this.originalSize = decompressedData.Length;
        //   m_bControlStream = true;
        //   m_streamData = decompressedData;
        //   decompressedData.SetLength( m_lOriginalSize );
        //   decompressedData.Capacity = ( int )m_lOriginalSize;
        if (this.checkCrc) {
            //TODO: fix this
            //CheckCrc(decompressedData.ToArray());
        }
        //m_streamData.Position = 0;
    }
    /// <summary>
    /// Extracts local header from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    readLocalHeader(stream) {
        if (stream.length == 0)
            throw new DOMException("stream");
        if (ZipArchive.ReadInt32(stream) != this.headerSignature)
            throw new DOMException("Can't find local header signature - wrong file format or file is corrupt.");
        // TODO: it is good to verify data read from the central directory record,
        // but on the current moment we simply skip it.
        stream.position += 22;
        let iNameLength = ZipArchive.ReadInt16(stream);
        let iExtraLength = ZipArchive.ReadUInt16(stream);
        if (this.compressionMethod == 99) //SecurityConstants.AES
         {
            // stream.Position += iNameLength + 8;
            // m_archive.EncryptionAlgorithm = (EncryptionAlgorithm)stream.ReadByte();
            // m_actualCompression = new byte[2];
            // stream.Read(m_actualCompression, 0, 2);
        }
        else if (iExtraLength > 2) {
            stream.position += iNameLength;
            let headerVal = ZipArchive.ReadInt16(stream);
            if (headerVal == 0x0017) //PKZipEncryptionHeader
                throw new DOMException("UnSupported");
            else
                stream.position += iExtraLength - 2;
        }
        else
            stream.position += iNameLength + iExtraLength;
    }
    /// <summary>
    /// Extracts compressed data from the stream.
    /// </summary>
    /// <param name="stream">Stream to read data from.</param>
    readCompressedData(stream) {
        let dataStream;
        if (this.compressedSize > 0) {
            let iBytesLeft = this.compressedSize;
            dataStream = new Stream(new Uint8Array(iBytesLeft));
            let arrBuffer = new Uint8Array(BufferSize);
            while (iBytesLeft > 0) {
                let iBytesToRead = Math.min(iBytesLeft, BufferSize);
                if (stream.read(arrBuffer, 0, iBytesToRead) != iBytesToRead)
                    throw new DOMException("End of file reached - wrong file format or file is corrupt.");
                dataStream.write(arrBuffer.subarray(0, iBytesToRead), 0, iBytesToRead);
                iBytesLeft -= iBytesToRead;
            }
            // if(m_archive.Password != null)
            // {
            //     byte[] dataBuffer = new byte[dataStream.Length];
            //     dataBuffer = dataStream.ToArray();
            //     dataStream=new MemoryStream( Decrypt(dataBuffer));
            // }
            this.compressedStream = new Uint8Array(dataStream.inputStream);
            // m_bControlStream = true;
        }
        else if (this.compressedSize < 0) //If compression size is negative, then read until the next header signature reached.
         {
            //   MemoryStream dataStream = new MemoryStream();
            //   int bt = 0;
            //   bool proceed=true;
            //   while (proceed)
            //   {
            //       if ((bt = stream.ReadByte()) == Constants.HeaderSignatureStartByteValue)
            //       {
            //           stream.Position -= 1;
            //           int headerSignature = ZipArchive.ReadInt32(stream);
            //           if (headerSignature==Constants.CentralHeaderSignature || headerSignature==Constants.CentralHeaderSignature)
            //           {
            //               proceed = false;
            //           }
            //           stream.Position -= 3;
            //       }
            //       if (proceed)
            //           dataStream.WriteByte((byte)bt);
            //   }
            //   m_streamData = dataStream;
            //   m_lCompressedSize = m_streamData.Length;
            //   m_bControlStream = true;
        }
        else if (this.compressedSize == 0) {
            //  m_streamData = new MemoryStream();
        }
    }
}
/**
 * Class represent unique ZipArchive item
 * ```typescript
 * let archiveItem = new ZipArchiveItem(archive, 'directoryName\fileName.txt');
 * ```
 */
export class ZipArchiveItem {
    get dataStream() {
        return this.decompressedStream;
    }
    /**
     * Get the name of archive item
     * @returns string
     */
    get name() {
        return this.fileName;
    }
    /**
     * Set the name of archive item
     * @param  {string} value
     */
    set name(value) {
        this.fileName = value;
    }
    /**
     * constructor for creating {ZipArchiveItem} instance
     * @param {Blob|ArrayBuffer} data file data
     * @param {itemName} itemName absolute file path
     */
    constructor(data, itemName) {
        if (data === null || data === undefined) {
            throw new Error('ArgumentException: data cannot be null or undefined');
        }
        if (itemName === null || itemName === undefined) {
            throw new Error('ArgumentException: string cannot be null or undefined');
        }
        if (itemName.length === 0) {
            throw new Error('string cannot be empty');
        }
        this.data = data;
        this.name = itemName;
    }
    /**
     * release allocated un-managed resource
     * @returns {void}
     */
    destroy() {
        this.fileName = undefined;
        this.data = undefined;
    }
}
/* eslint-enable */ 
